import { Sphere } from './OctreeGeometry';
export class OctreeGeometryNode {
    name;
    octreeGeometry;
    boundingBox;
    constructor(name, octreeGeometry, boundingBox) {
        this.name = name;
        this.octreeGeometry = octreeGeometry;
        this.boundingBox = boundingBox;
        this.id = OctreeGeometryNode.IDCount++;
        this.index = parseInt(name.charAt(name.length - 1));
        this.boundingSphere = boundingBox.getBoundingSphere(new Sphere());
        this.numPoints = 0;
        this.oneTimeDisposeHandlers = [];
    }
    loaded = false;
    loading = false;
    // eslint-disable-next-line no-use-before-define
    parent = null;
    geometry = null;
    nodeType;
    byteOffset;
    byteSize;
    hierarchyByteOffset;
    hierarchyByteSize;
    hasChildren = false;
    spacing;
    density;
    isLeafNode = true;
    isTreeNode = false;
    isGeometryNode = true;
    // eslint-disable-next-line no-use-before-define
    children = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
    ];
    // create static IDCount variable
    static IDCount = 0;
    id;
    index;
    boundingSphere;
    numPoints;
    level;
    oneTimeDisposeHandlers;
    getLevel() {
        return this.level;
    }
    isLoaded() {
        return this.loaded;
    }
    getBoundingSphere() {
        return this.boundingSphere;
    }
    getBoundingBox() {
        return this.boundingBox;
    }
    load() {
        if (this.octreeGeometry.numNodesLoading >=
            this.octreeGeometry.maxNumNodesLoading) {
            return;
        }
        if (this.octreeGeometry.loader) {
            return this.octreeGeometry.loader.load(this);
        }
    }
    getNumPoints() {
        return this.numPoints;
    }
    dispose() {
        if (this.geometry && this.parent != null) {
            this.geometry.dispose();
            this.geometry = null;
            this.loaded = false;
            for (let i = 0; i < this.oneTimeDisposeHandlers.length; i++) {
                const handler = this.oneTimeDisposeHandlers[i];
                handler();
            }
            this.oneTimeDisposeHandlers = [];
        }
    }
    traverse(cb, includeSelf = true) {
        const stack = includeSelf ? [this] : [];
        let current;
        while ((current = stack.pop()) !== undefined) {
            cb(current);
            for (const child of current.children) {
                if (child !== null) {
                    stack.push(child);
                }
            }
        }
    }
}
OctreeGeometryNode.IDCount = 0;
